export default "__VITE_ASSET__B53Wvnbg__"